/* @bend-expect quartz-no-create-browser-history */

import { getParsedTrackingParams } from 'marketplace-ui-common/utils/trackingParams';
import { getMarketplaceEventProps } from 'marketplace-ui-tracking';
import { createTracker as createLegacyTracker } from 'usage-tracker';
import { createContainer } from 'usage-tracker-multi';
function getSessionUrlParams() {
  const trackingParams = getParsedTrackingParams();
  return Object.keys(trackingParams).reduce((final, key) => {
    const value = trackingParams[key];
    final.push(`${key}=${value}`);
    return final;
  }, []);
}
let trackContainer;
let tracker;
export function createStandaloneTracker({
  appContext,
  history,
  referrer
}) {
  if (!trackContainer) {
    trackContainer = createContainer({
      history
    });
  }
  if (!tracker) {
    tracker = trackContainer.createTracker({
      standalone: true,
      trackerType: appContext === 'app' ? 'authed' : 'public',
      properties: getMarketplaceEventProps({
        inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
        referrer,
        sessionUrlParams: getSessionUrlParams()
      }),
      lastKnownEventProperties: ['screen']
    });
  }
  return tracker;
}
export function createTracker({
  appContext,
  referrer
}) {
  return createLegacyTracker({
    lastKnownEventProperties: ['screen'],
    properties: {
      inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
      namespace: 'marketplace',
      referrer,
      sessionUrlParams: getSessionUrlParams()
    }
  });
}

/**
 * ListingCard Search Result Event Props
 */

export function getSourceIdByCard(card) {
  return card.products.map(({
    sourceId,
    productType
  }) => `${String(productType)}__${sourceId}`);
}
export function getInstalledByCard(card) {
  var _card$products$;
  return Boolean((_card$products$ = card.products[0]) === null || _card$products$ === void 0 ? void 0 : _card$products$.installed);
}

// TODO: add typeguard
export function getProductTypeByCard(card) {
  return card.products.length ? card.products[0].productType : undefined;
}

/**
 * AutocompleteResultItem Search Result Event Props
 */

// TODO: add typeguard
export function getProductTypeByAutocompleteResultItem(item) {
  return item.productTypes.length ? item.productTypes[0] : undefined;
}
export function getSourceIdByAutocompleteResultItem(item) {
  return item.sourceIds.map((sourceId, index) => {
    var _item$productTypes$in;
    return `${String((_item$productTypes$in = item.productTypes[index]) !== null && _item$productTypes$in !== void 0 ? _item$productTypes$in : item.productTypes[0])}__${sourceId}`;
  });
}